import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=39bb5743&"
import script from "./certification.vue?vue&type=script&lang=ts&"
export * from "./certification.vue?vue&type=script&lang=ts&"
import style0 from "./certification.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports